import React from 'react';
import styled from 'styled-components';
import SingleProduct from '../../components/cards/singleCard';
import Loading from '../loading';

const Container = styled.div`
    background-color:${props => props.theme.colors[props.bgColor]};
    padding:${props => props.theme.spacing.inset};

    @media (min-width: 1281px) {
        width:1280px;
        margin-left:auto;
        margin-right:auto;
        padding-left:0;
        padding-right:0;
        display:flex;
        flex-direction:row;
        flex-wrap:wrap;
    }
    @media (max-width: 1280px) {
        display:flex;
        flex-direction:row;
        flex-wrap:wrap;
    }
    @media (max-width: 1000px) {
        display:flex;
        flex-direction:column;
        flex-wrap:no-wrap;
    }
`;

const ProductsArea = ({ posts = [], loading = true }) => {
    if (loading) return <Loading fullHeight={false} />;
    return (
        <Container bgColor="defaultQuarterly">
            {posts?.length > 0 && posts.map((productItem, i) => <SingleProduct key={`productItem` + i} {...productItem} />)}
        </Container>
    );
}
export default ProductsArea;
